import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

// in-memory session token (never persisted) so sign-in works even where the browser blocks the cookie
let sessionToken = null;
export const setSessionToken = (t) => { sessionToken = t || null; };
api.interceptors.request.use((cfg) => {
  if (sessionToken) cfg.headers.Authorization = `Bearer ${sessionToken}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const CURRENCIES = { USD: ["$", "US Dollar"], GBP: ["£", "British Pound"], EUR: ["€", "Euro"], NGN: ["₦", "Nigerian Naira"], KES: ["KSh", "Kenyan Shilling"], ZAR: ["R", "South African Rand"], ZMW: ["K", "Zambian Kwacha"] };
export const CURRENCY_OPTS = Object.entries(CURRENCIES).map(([k, [s, n]]) => ({ value: k, label: `${k} — ${n} (${s})` }));
export const money = (n, cur = "USD") => {
  if (n == null) return "—";
  const sym = CURRENCIES[cur]?.[0] ?? cur;
  return `${sym}${sym.length > 1 ? " " : ""}${Number(n).toLocaleString("en-GB", { maximumFractionDigits: 0 })}`;
};
export const fmtUnit = (v, u) => (CURRENCIES[u] ? money(v, u) : `${Number(v).toLocaleString()} ${u || ""}`);

export const ROLE_LABELS = {
  pm: "Project Manager", pgm: "Project Director", coordinator: "Project Coordinator", tech_lead: "Technical Lead",
  project_admin: "Project Administrator", finance: "Project Finance", pmo: "PMO", psc: "Steering Committee",
  cab: "Change Approval Board", team_member: "Team Member", stakeholder: "Stakeholder / Vendor", sysadmin: "System Administrator",
};

export async function downloadFile(path, filename) {
  let res;
  try {
    res = await api.get(path, { responseType: "blob" });
  } catch (e) {
    const blob = e?.response?.data;
    if (blob instanceof Blob) {
      try {
        e.response.data = JSON.parse(await blob.text());
      } catch (_) {}
    }
    throw e;
  }
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
